<h1 mat-dialog-title>{{ data.title }}</h1>

<div mat-dialog-content class="je-tier__content">
    <p class="je-tier__lead">
        Gewicht <strong>je Tier</strong> nachtragen. Vorhandene Werte bleiben geschützt (Einzelgewicht) und werden
        bei Listen-Durchschnitt nicht überschrieben, solange Sie nicht „Alle überschreiben“ wählen.
    </p>

    <div class="je-tier__loading" *ngIf="isLoading">
        <mat-spinner diameter="32"></mat-spinner>
    </div>

    <div class="je-tier__list" *ngIf="!isLoading" [formGroup]="form">
        <div class="je-tier__row" *ngFor="let animal of animals">
            <span class="je-tier__ohrmarke">{{ animal.ohrmarke }}</span>
            <mat-form-field appearance="outline" class="je-tier__field">
                <mat-label>{{ data.unit }}</mat-label>
                <input
                    matInput
                    type="number"
                    inputmode="decimal"
                    step="0.01"
                    min="0.01"
                    [formControl]="ctrlFor(animal.gt_id)"
                />
                <span matSuffix>{{ data.unit }}</span>
            </mat-form-field>
        </div>
        <p class="je-tier__hint" *ngIf="!animals.length">Keine Tiere auf der Liste.</p>
    </div>
</div>

<div mat-dialog-actions class="je-tier__actions">
    <button type="button" mat-button (click)="cancel()" [disabled]="isSaving">Abbrechen</button>
    <button
        type="button"
        mat-flat-button
        color="accent"
        data-cy="je-tier-save"
        (click)="save()"
        [disabled]="isSaving || isLoading || !animals.length"
    >
        Speichern
    </button>
</div>
